// extracted by mini-css-extract-plugin
export const previewTitle = "article-preview-module--previewTitle--295gz";
export const tag = "article-preview-module--tag---JlLV";